"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginCallbackScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_ui_1 = require("@pasport/react-ui");
const hooks_1 = require("../hooks");
const react_router_dom_1 = require("react-router-dom");
const LoginCallbackScreen = () => {
    const { loginByAuthCode } = (0, hooks_1.useAuthProcess)();
    const { isLogged } = (0, hooks_1.useAuthTokens)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    let urlObject = new URL(window.location.href.replace(/#/g, "?"));
    let authCode = urlObject.searchParams.get("code");
    let backUrl = urlObject.searchParams.get("state");
    const alreadyProcessed = (0, react_1.useRef)(false);
    const redirectBack = () => {
        if (backUrl) {
            const isSameRoute = (0, react_router_dom_1.matchPath)({
                path: "/login",
                end: false
            }, backUrl);
            if (isSameRoute || backUrl.startsWith("http"))
                navigate('/');
            else
                navigate(backUrl);
        }
    };
    (0, react_1.useEffect)(() => {
        if (authCode && !isLogged && !alreadyProcessed.current) {
            alreadyProcessed.current = true;
            loginByAuthCode(authCode).catch(() => {
                redirectBack();
            });
        }
    }, [authCode, isLogged, alreadyProcessed.current]);
    (0, react_1.useEffect)(() => {
        if (authCode && isLogged) {
            redirectBack();
        }
    }, [authCode, isLogged]);
    return (0, jsx_runtime_1.jsx)(react_ui_1.CenterView, { children: "P\u0159ihla\u0161ov\u00E1n\u00ED ..." });
};
exports.LoginCallbackScreen = LoginCallbackScreen;
